var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCornerBrassBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16H0L16 0v12a4 4 0 01-4 4z",
    fill: "url(#paint1_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 15.5H12a3.5 3.5 0 003.5-3.5V1.2L1.2 15.5z",
    stroke: "#FFAF9D",
    strokeOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 8,
    y1: 6.5,
    x2: 16.38,
    y2: 15.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3AA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#734B3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerBrassBr);
export default __webpack_public_path__ + "static/media/corner-brass-br.d2f35f528fa48cf59582669cc97232db.svg";
export { ForwardRef as ReactComponent };